import React from 'react';

interface VehicleSpecsProps {
  specs: Record<string, Record<string, string>>;
}

const VehicleSpecs: React.FC<VehicleSpecsProps> = ({ specs }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Specifications</h2>
      {Object.entries(specs).map(([category, values]) => {
  if (!values || Object.keys(values).length === 0) return null;
  return (
    <div key={category} className="bg-white rounded shadow p-4">
      <h3 className="text-lg font-bold mb-2 capitalize">{category}</h3>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {Object.entries(values).map(([label, value]) => (
          <li key={label} className="flex justify-between border-b py-1">
            <span className="font-medium">{label}</span>
            <span>{value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
})}
    </div>
  );
};

export default VehicleSpecs;
